import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { IAccountActivationPayload, IAccountActivationResponse } from '../../../entity';

export interface ISendAccountActivationUseCase {
    execute(
        payload: IAccountActivationPayload,
        csrfToken: { [key: string]: string }
    ): Promise<IAccountActivationResponse>;
}

export class SendAccountActivationUseCase implements ISendAccountActivationUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        payload: IAccountActivationPayload,
        csrfToken: { [key: string]: string }
    ): Promise<IAccountActivationResponse> {
        return await this.userRepo.sendAccountActivation(payload, csrfToken);
    }
}
